<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import AppLayout from './components/AppLayout.vue'
import AuthLayout from './components/AuthLayout.vue'
import { useSession } from './stores/session'

const route = useRoute()
const session = useSession()
// The invitation page is public: bare layout for guests, app shell when signed in.
const bare = computed(() => route.meta.guest || (route.meta.public && !session.authenticated))
</script>

<template>
  <div v-if="!session.ready" class="boot" aria-busy="true">{{ $t('common.loading') }}</div>
  <AuthLayout v-else-if="bare"><RouterView /></AuthLayout>
  <AppLayout v-else><RouterView /></AppLayout>
</template>

<style scoped>
.boot {
  min-height: 100vh;
  display: grid;
  place-items: center;
  color: var(--fg-muted);
}
</style>
